import React, { Component } from 'react'
import FadeIn from 'react-fade-in'

import { withTranslation } from 'react-i18next'
import { Jumbotron, Container } from 'react-bootstrap'

import './style.css'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.log('***ErrorBoundary***', error, errorInfo)
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <FadeIn>
          <div className='not-found-container container-fluid text-left text-sm-center'>
            <div className='row h-100'>
              <div className='col my-auto'>
                <div className='row'>
                  <div className='col col-sm-8 offset-sm-2'>
                    <Jumbotron fluid className='axs-shadow lead'>
                      <Container>
                        <p style={{ fontSize: 'xx-large' }}>
                          {this.props.t('Oh no! Something went wrong')}
                        </p>
                        <p>
                          {this.props.t(
                            'Please refresh the page and try again while we fix the error.'
                          )}
                        </p>

                        <p>{this.props.t('Thank you for your patience.')}</p>

                        <a
                          className='btn btn-link'
                          onClick={() => window.location.reload()}
                        >
                          {this.props.t('Click here to refresh')}
                        </a>
                      </Container>
                    </Jumbotron>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      )
    }

    return this.props.children
  }
}

export default withTranslation()(ErrorBoundary)
